<template>
  <div class="wx-qrcode-wrap" v-if="visible">
    <div class="close-btn" @click="close">
      <img src="@saas/pages/assets/images/close.png" alt="" />
    </div>
    <div>
      <p class="title">微信咨询</p>
      <img class="qrcode" :src="qrCodeUrl" alt="" />
      <p class="tips">手机扫码加我微信</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      qrCodeUrl: `${
        process.env.VUE_APP_CDN_URL
      }/cdn/static/images/kehu_zixun_qrcode.png?t=${Date.now()}`,
    };
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.wx-qrcode-wrap {
  z-index: 1001;
  transition: all 0.5s;
  width: 339px;
  height: 378px;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);
  border-radius: 12px;
  border: 1px solid #f2f3f5;
  background-image: url("../../../assets/images/settle-in/dialog-bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .close-btn {
    position: absolute;
    right: 16px;
    top: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    padding: 0;
    img {
      width: 20px;
      height: 20px;
    }
  }
  & > div {
    height: 100%;
    padding-top: 29px;
  }
  .title {
    text-align: center;
    font-weight: 500;
    font-size: 26px;
    color: #000000;
    line-height: 37px;
    margin-bottom: 22px;
  }
  .qrcode {
    width: 215px;
    height: 215px;
    margin: 0 auto 20px;
  }
  .tips {
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    color: #0d1400;
    line-height: 25px;
    letter-spacing: 6px;
  }
}
</style>
